// eslint-disable-next-line no-unused-vars

export var UtilsMixin = {
  name:"UtilsMixin",
  
  methods: {
    async Sort(array, param){
      if(!(array && array.length))
        return array; 

      if(param){
        await array.sort((obj1, obj2) => {
          if(obj1[param] > obj2[param]) 
            return 1;
          if(obj1[param] < obj2[param]) 
            return -1;
          return 0;
        })
        return array;
      }
      return array.sort();
    },

    async SortDate(array, param){
      if(!(array && array.length))
        return array; 

      if(param){
        await array.sort((obj1, obj2) => {
          if(obj1[param] == '-')
            return -1;
          if(obj2[param] == '-')
            return 1;
          if(obj1[param] == '-' && obj2[param] == '-')
            return 0;

          let date1 = obj1[param].split("/");
          let date2 = obj2[param].split("/");
          
          if( new Date(parseInt(date1[2]), parseInt(date1[1]), parseInt(date1[0])) > 
              new Date(parseInt(date2[2]), parseInt(date2[1]), parseInt(date2[0])))
            return 1;

          if( new Date(parseInt(date1[2]), parseInt(date1[1]), parseInt(date1[0])) < 
              new Date(parseInt(date2[2]), parseInt(date2[1]), parseInt(date2[0]))) 
            return -1;
          
          return 0;
        })
        return array;
      }
      return array.sort();
    }
  }
};
